import { render, staticRenderFns } from "./numberMonitoring.vue?vue&type=template&id=0c60b856&scoped=true"
import script from "./numberMonitoring.vue?vue&type=script&lang=js"
export * from "./numberMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c60b856",
  null
  
)

export default component.exports